/**
 * Directive: resourceField
 */
angular.module('acme.common.directive.resourceField', [
  'acme.common.directive.resourceFieldEdit',
  'acme.common.directive.resourceFieldCreate',
  'acme.common.directive.resourceFieldDetail',
  'acme.common.directive.inputField',
  'acme.common.directive.textareaField'
])
.directive('resourceField', [function() {

    return {
      restrict: 'A',
      replace: true,
      templateUrl: 'common/directives/resourceField/resourceField.tpl.html',
      scope: {
        state: '@',
        field: '=',
        entity: '=',
        fieldIndex: '@fieldindex',
        resourceTemplateId: '@resourcetemplateid',
        disableEdit: '@disableedit'
      },
      link: function($scope, $element, $attrs) {
        // Modified after controller runs

      },

      controller: ['$scope', function($scope) {

        $scope.resourceField = {

          init: function() {
            $scope.$on('resourceField::stateChange', this.onResourceFieldStateChange);
            $scope.$on('resourceField::remove', this.onResourceFieldRemove);
          },

          isEditEnabled: function() {
            // Normalize
            return ($scope.disableEdit);
          },

          isInState: function(state) {
            return ($scope.state === state);
          },

          onResourceFieldStateChange: function(e, data) {
            $scope.state = data.state;
          },

          onResourceFieldRemove: function(e, data) {
            // No handler necessary
          }

        };

        $scope.resourceField.init();


      }]

    };

}]);